import { http, newIdempotencyKey, type Page } from '@shared/api';
import type {
  BuyRequest,
  BuyRequestFeedQuery,
  Quote,
  SubmitQuoteRequest,
} from '../model/types';

function buildFeedParams(query: BuyRequestFeedQuery): URLSearchParams {
  const p = new URLSearchParams();
  if (query.category) p.set('category', query.category);
  if (query.country) p.set('country', query.country);
  if (query.q) p.set('q', query.q);
  p.set('page', String(query.page ?? 0));
  p.set('size', String(query.size ?? 20));
  return p;
}

export const rfqApi = {
  feed: (query: BuyRequestFeedQuery) =>
    http.get('buy-requests/feed', { searchParams: buildFeedParams(query) }).json<Page<BuyRequest>>(),

  // v1.2 — single RFQ by id. 403/404 per spec — see useBuyRequestQuery for UX handling.
  get: (id: string) => http.get(`buy-requests/${id}`).json<BuyRequest>(),

  submitQuote: (
    buyRequestId: string,
    body: SubmitQuoteRequest,
    idempotencyKey: string = newIdempotencyKey(),
  ) =>
    http
      .post(`buy-requests/${buyRequestId}/quote`, {
        json: body,
        headers: { 'Idempotency-Key': idempotencyKey },
      })
      .json<Quote>(),

  myQuotes: (page = 0, size = 20) =>
    http
      .get('quotes', { searchParams: { page: String(page), size: String(size) } })
      .json<Page<Quote>>(),

  withdrawQuote: (quoteId: string) => http.post(`quotes/${quoteId}/withdraw`).json<Quote>(),
};
